import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Kalkulator Nilai Ujian - Hitung Nilai Ujian";
const DESCRIPTION =
  "Hitung nilai dan persentase ujian Anda dengan mudah menggunakan kalkulator nilai canggih. Dapatkan persentase dan nilai huruf berdasarkan jumlah poin dan jawaban salah.";
const KEYWORDS =
  "kalkulator nilai, hitung persentase nilai, hitung nilai ujian, kalkulator persentase, estimasi nilai, kalkulator nilai ujian, kalkulator nilai tes, alat hitung nilai";
const OG_URL = "https://do-calculate.com/calculator/id/test-grade";
function GradeCalculator() {
  const [points, setPoints] = useState("");
  const [wrong, setWrong] = useState("");
  const [correct, setCorrect] = useState("");
  const [percentage, setPercentage] = useState("");
  const [grade, setGrade] = useState("");
  useEffect(() => {
    const pointsValue = parseFloat(points) || 0;
    const wrongValue = parseFloat(wrong) || 0;
    const correctValue = parseFloat(correct) || 0;
    if (pointsValue > 0) {
      if (wrong !== "" && correct === "") {
        const calculatedCorrect = pointsValue - wrongValue;
        setCorrect(calculatedCorrect >= 0 ? calculatedCorrect.toString() : "");
      } else if (correct !== "" && wrong === "") {
        const calculatedWrong = pointsValue - correctValue;
        setWrong(calculatedWrong >= 0 ? calculatedWrong.toString() : "");
      }
      const finalCorrect =
        wrong !== "" ? pointsValue - wrongValue : correctValue;
      if (finalCorrect >= 0 && finalCorrect <= pointsValue) {
        const percentageValue = (finalCorrect / pointsValue) * 100;
        setPercentage(Math.round(percentageValue * 100) / 100);
        let gradeValue = "";
        if (percentageValue >= 90) {
          gradeValue = "A";
        } else if (percentageValue >= 80) {
          gradeValue = "B";
        } else if (percentageValue >= 70) {
          gradeValue = "C";
        } else if (percentageValue >= 60) {
          gradeValue = "D";
        } else {
          gradeValue = "F";
        }
        setGrade(gradeValue);
      } else {
        setCorrect("");
        setPercentage("");
        setGrade("");
      }
    }
  }, [points, wrong, correct]);
  const handlePointsChange = (e) => setPoints(e.target.value);
  const handleWrongChange = (e) => {
    setWrong(e.target.value);
    if (points !== "") {
      setCorrect((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  const handleCorrectChange = (e) => {
    setCorrect(e.target.value);
    if (points !== "") {
      setWrong((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            Kalkulator nilai ujian ini adalah alat yang sangat diperlukan jika Anda mencari alat untuk membantu menentukan skala nilai. Juga dikenal sebagai kalkulator nilai ujian atau alat penilaian guru, alat ini memungkinkan Anda dengan cepat menemukan nilai dan persentase berdasarkan jumlah poin dan jawaban salah (atau benar). Selain itu, Anda dapat mengubah skala nilai default dan menetapkan skala Anda sendiri. Masih bertanya-tanya bagaimana cara menghitung nilai ujian? Gulir ke bawah untuk mempelajari lebih lanjut – atau cukup coba kalkulator skala nilai ini.
          </p>
           <MobileUnderCalAds />
          <div className="border border-light p-3">
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="pointsInput">
                        Poin / Pertanyaan ❔
                      </label>
                    </b>
                    <input
                      id="pointsInput"
                      type="number"
                      placeholder="Jumlah poin"
                      value={points}
                      onChange={handlePointsChange}
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="wrongInput">
                        Jawaban Salah ❌
                      </label>
                    </b>
                    <input
                      id="wrongInput"
                      type="number"
                      placeholder="Jumlah jawaban salah"
                      value={wrong}
                      onChange={handleWrongChange}
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="correctInput">
                        Jawaban Benar ✔️
                      </label>
                    </b>
                    <input
                      id="correctInput"
                      type="number"
                      placeholder="Jumlah jawaban benar"
                      value={correct}
                      onChange={handleCorrectChange}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="percentageInput"
                      >
                        Persentase %
                      </label>
                    </b>
                    <input
                      id="percentageInput"
                      type="text"
                      placeholder="Persentase"
                      value={percentage}
                      readOnly
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="gradeInput">
                        Nilai
                      </label>
                    </b>
                    <input
                      id="gradeInput"
                      type="text"
                      placeholder="Nilai"
                      value={grade}
                      readOnly
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Cara Menghitung Nilai Ujian
                    </h2>
                  </u>
                  <p>
                    Untuk menghitung persentase nilai ujian, yang Anda perlukan adalah membagi poin yang diperoleh dengan total poin yang mungkin. Dengan kata lain, Anda cukup mencari proporsi jawaban yang benar:
                  </p>
                  <p>
                    <b>
                      Persentase Nilai = (Jumlah Jawaban Benar / Total Pertanyaan) × 100
                    </b>
                  </p>
                  <p>
                    Karena jumlah jawaban benar + jumlah jawaban salah = total pertanyaan, kita dapat menulis persamaan sebagai:
                  </p>
                  <p>
                    <b>
                      Persentase Nilai = 100 × (Total Pertanyaan - Jumlah Jawaban Salah) / Total Pertanyaan
                    </b>
                  </p>
                  <p>
                    Setelah itu, yang harus Anda lakukan adalah mengubah persentase menjadi nilai huruf. Skala nilai default ditunjukkan dalam tabel di bawah ini:
                  </p>
                  <table >
                    <thead>
                      <tr>
                        <th >Nilai Huruf</th>
                        <th >Persentase</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A+</td>
                        <td>97-100</td>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>93-96</td>
                      </tr>
                      <tr>
                        <td>A-</td>
                        <td>90-92</td>
                      </tr>
                      <tr>
                        <td>B+</td>
                        <td>87-89</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>83-86</td>
                      </tr>
                      <tr>
                        <td>B-</td>
                        <td>80-82</td>
                      </tr>
                      <tr>
                        <td>C+</td>
                        <td>77-79</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>73-76</td>
                      </tr>
                      <tr>
                        <td>C-</td>
                        <td>70-72</td>
                      </tr>
                      <tr>
                        <td>D+</td>
                        <td>67-69</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>63-66</td>
                      </tr>
                      <tr>
                        <td>D-</td>
                        <td>60-62</td>
                      </tr>
                      <tr>
                        <td>F</td>
                        <td>Kurang dari 60</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    Jika Anda lebih suka tidak menggunakan nilai dengan tanda plus atau minus, skala mungkin terlihat seperti ini:
                  </p>
                  <ul>
                    <li>A dari 90% hingga 100%</li>
                    <li>B dari 80% hingga 89%</li>
                    <li>C dari 70% hingga 79%</li>
                    <li>D dari 60% hingga 69%</li>
                    <li>F dari 59% ke bawah – ini bukan nilai lulus</li>
                  </ul>
                  <p>
                    Di atas, Anda dapat menemukan sistem nilai standar untuk sekolah dan universitas Amerika. Namun, nilai dapat bervariasi antar sekolah, kelas, dan guru. Selalu periksa terlebih dahulu sistem yang digunakan dalam kasus Anda.
                  </p>
                  <p>
                    Terkadang batas nilai lulus bukan 60%, tetapi misalnya, 50% atau 65%. Bagaimana selanjutnya? Kami telah membahas ini – Anda dapat mengubah rentang untuk setiap nilai! Baca lebih lanjut tentang ini di bagian terakhir artikel ini: opsi mode lanjutan.
                  </p>
                  <p>
                    Anda mungkin juga tertarik dengan kalkulator nilai semester dan kalkulator nilai akhir.
                  </p>
                  <h2 style={{ fontSize: "16px" }}>
                    Kalkulator Nilai Ujian – Bagaimana Cara Menggunakannya?
                  </h2>
                  <p>
                    Kalkulator nilai ujian kami adalah alat yang sederhana dan mudah digunakan!
                  </p>
                  <p>
                    Masukkan jumlah pertanyaan/poin/masalah dalam tugas siswa (tes, ujian, apa pun). Anggaplah Anda menyiapkan tes dengan 18 pertanyaan.
                  </p>
                  <p>
                    Tulis jumlah pertanyaan yang dijawab salah oleh siswa. Atau – jika Anda lebih suka – Anda dapat memasukkan jumlah poin yang diperoleh. Mari kita asumsikan siswa teladan kita menjawab salah tiga pertanyaan.
                  </p>
                  <p>
                    Ini dia! Alat penilaian guru menampilkan persentase dan nilai untuk ujian ini. Dalam contoh kami, siswa mendapat 83,33% dalam ujian, yang setara dengan nilai B.
                  </p>
                  <p>
                    Di bawah ini Anda akan menemukan tabel skala nilai lengkap. Jadi, untuk memeriksa nilai siswa berikutnya, Anda dapat menulis jumlah pertanyaan yang mereka jawab salah – atau cukup gunakan tabel yang bagus ini.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeCalculator;